import actionsTypes from '../actionTypes';

const defaultState = {
  cartList: [],
  cartListLoading: false,
  totalCartAmount: 0,
  totalPaymentWithShipmentFees: 0
};

/**
 *
 *
 * @param {*} [state=defaultState]
 * @param {*} action
 * @returns
 */
const cartReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionsTypes.CART_LIST_LOADING: {
      return {
        ...state,
        cartListLoading: action.payload,
      };
    }
    case actionsTypes.SET_CART_LIST: {
      return {
        ...state,
        cartList: action.payload.cartList,

      }
    }
    case actionsTypes.SET_TOTAL_CART_PRICE_AMOUNT: {
      return {
        ...state,
        totalCartAmount: action.payload,
      }
    }
    case actionsTypes.SET_TOTAL_PRICE_AMOUNT: {
      return {
        ...state,
        totalPaymentWithShipmentFees: action.payload,
      }
    }

    case actionsTypes.SET_SHIPMENT_FEE_DETAIL: {
      return {
        ...state,
        shipmentFees: action.payload.fees,
        shipmentFeesCurrency: action.payload.shipmentFeesCurrency
      }
    }
    default:
      return state;
  }
};

export default cartReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/cart.reducer.js